import React, { PureComponent, Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import combineStyles from '../../utils/combineStyles';
import CollapseWrapperStyles from '../../styles/components/collapseWrapper';
import TypographyStyles from '../../styles/typography';
import ButtonStyles from '../../styles/button';
import SpacingStyles from '../../styles/helpers/spacing';
import DetailsSectionStyles from './__styles__/DetailsSection.styles';

import CollapseWrapper from '../Global/CollapseWrapper';

export class DetailsSection extends PureComponent {
  render() {
    const { t, classes } = this.props;
    return (
      <CollapseWrapper
        classes={{
          root: classes.root,
          header: classes.panelHeader,
          expandButton: classes.expandButton,
          bodyRoot: classes.collapsePanelBodyRoot
        }}
        header={() => (
          <div className={classes.titleWrapper}>
            <h2 className={classnames(classes.headline8, classes.title)}>
              {t('Shipment Details')}
            </h2>
          </div>
        )}
        body={
          <Fragment>
            <Divider />
            <div className={classes.body}>
              <p className={classnames(classes.headline6, classes.totalPrice)}>
                $150.00
              </p>
              <Grid container spacing={24}>
                <Grid item xs={6}>
                  <p
                    className={classnames(
                      classes.subtitle3,
                      classes.detailAttributeName
                    )}
                  >
                    {t('Accessorials')}{' '}
                    {<ExpandMoreIcon className={classes.expandMoreAttribute} />}
                  </p>
                  <p className={classes.body2}>$50.00</p>
                </Grid>
                <Grid item xs={3}>
                  <p
                    className={classnames(
                      classes.subtitle3,
                      classes.detailAttributeName
                    )}
                  >
                    {t('Line Haul')}
                  </p>
                  <p className={classes.body2}>$50.00</p>
                </Grid>
                <Grid item xs={3}>
                  <p
                    className={classnames(
                      classes.subtitle3,
                      classes.detailAttributeName
                    )}
                  >
                    {t('Fuel')}
                  </p>
                  <p className={classes.body2}>$50.00</p>
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
              <Grid container spacing={24}>
                <Grid item xs={6}>
                  <p
                    className={classnames(
                      classes.subtitle3,
                      classes.detailAttributeName
                    )}
                  >
                    {t('BOL Number')}
                  </p>
                  <p className={classes.body2}>00987623451223</p>
                </Grid>
                <Grid item xs={6}>
                  <p
                    className={classnames(
                      classes.subtitle3,
                      classes.detailAttributeName
                    )}
                  >
                    {t('PRO Number')}
                  </p>
                  <p className={classes.body2}>57635476-44</p>
                </Grid>
                <Grid item xs={6}>
                  <p
                    className={classnames(
                      classes.subtitle3,
                      classes.detailAttributeName
                    )}
                  >
                    {t('GL Code')}
                  </p>
                  <p className={classes.body2}>ABC1234987</p>
                </Grid>
                <Grid item xs={6}>
                  <p
                    className={classnames(
                      classes.subtitle3,
                      classes.detailAttributeName
                    )}
                  >
                    {t('Delivery Date')}
                  </p>
                  <p className={classes.body2}>January 1, 2019</p>
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
              <Grid container spacing={24}>
                <Grid item xs={12}>
                  <p
                    className={classnames(
                      classes.subtitle3,
                      classes.detailAttributeName
                    )}
                  >
                    {t('Pickup')}{' '}
                    <span className={classnames(classes.caption, classes.tag)}>
                      Billing Address
                    </span>
                  </p>
                  <p className={classes.body2}>Business Name ABCD</p>
                  <p className={classes.body2}>12345 Main Street</p>
                  <p className={classes.body2}>Los Angeles, CA 55555 USA</p>
                </Grid>
                <Grid item xs={12}>
                  <p
                    className={classnames(
                      classes.subtitle3,
                      classes.detailAttributeName
                    )}
                  >
                    {t('Delivery')}
                  </p>
                  <p className={classes.body2}>Business Name EFGH</p>
                  <p className={classes.body2}>555 First Street, Apt. A</p>
                  <p className={classes.body2}>New York, NY 55555 USA</p>
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
              <div>
                <p
                  className={classnames(
                    classes.subtitle3,
                    classes.detailAttributeName,
                    classes.noMarginBottom
                  )}
                >
                  {t('Shipment Contents')}
                </p>
                <CollapseWrapper
                  classes={{
                    root: classnames(classes.rootUnit),
                    expandButton: classes.unitExpandButton
                  }}
                  header={
                    <div className={classes.titleWrapper}>
                      <h2
                        className={classnames(
                          classes.caption,
                          classes.unitTitle
                        )}
                      >
                        UNIT 1
                      </h2>
                      <p
                        className={classnames(
                          classes.caption,
                          classes.unitWeightInfo
                        )}
                      >
                        500 lbs (Class 12)
                      </p>
                      <p className={classes.spacer} />
                      <p
                        className={classnames(
                          classes.caption,
                          classes.unitContainer
                        )}
                      >
                        1 Pallet
                      </p>
                    </div>
                  }
                  body={<div>Content goes here</div>}
                />
                <CollapseWrapper
                  classes={{
                    root: classnames(classes.rootUnit),
                    expandButton: classes.unitExpandButton
                  }}
                  header={
                    <div className={classes.titleWrapper}>
                      <h2
                        className={classnames(
                          classes.caption,
                          classes.unitTitle
                        )}
                      >
                        UNIT 2
                      </h2>
                      <p
                        className={classnames(
                          classes.caption,
                          classes.unitWeightInfo
                        )}
                      >
                        500 lbs (Class 12)
                      </p>
                      <p className={classes.spacer} />
                      <p
                        className={classnames(
                          classes.caption,
                          classes.unitContainer
                        )}
                      >
                        1 Pallet
                      </p>
                    </div>
                  }
                  body={<div>Content goes here</div>}
                />
              </div>
              <Divider className={classes.divider} />
              <div>
                <Button
                  variant={'outlined'}
                  className={classnames(classes.button, classes.actionButton)}
                  onClick={() => {}}
                  color={'primary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {t('View Shipment Comments')}
                </Button>
                <Button
                  variant={'outlined'}
                  className={classnames(classes.button, classes.actionButton)}
                  onClick={() => {}}
                  color={'primary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {t('View Shipment Activity')}
                </Button>
              </div>
            </div>
          </Fragment>
        }
      />
    );
  }
}

export default withStyles(
  combineStyles(
    DetailsSectionStyles,
    ButtonStyles,
    SpacingStyles,
    CollapseWrapperStyles,
    TypographyStyles
  )
)(withNamespaces()(DetailsSection));
